<template>
  <v-card
    class="pa-4 overflow-hidden card-container d-flex flex-column justify-space-between"
    min-height="176"
    outlined
  >
    <v-skeleton-loader type="text" width="120" />

    <v-skeleton-loader type="paragraph" width="160" />

    <v-skeleton-loader type="text" width="60" />
  </v-card>
</template>

<script>
export default {
  name: 'TeamCardSkeleton',
}
</script>
